export function initLanscapeDesign(design) {
    const init = {
        budgetMax: 0,
        desiredInstallDate: new Date(),
        propertyInformation: {
            facingDirections: [],
            sun: '',
            wind: '',
            moisture: '',
            soilIssues: [],
            wildlife: [],
            proximityTrees: false,
            undergroundObstacles: [],
            address: '',
            city: '',
            state: '',
            zip: '',
            comments: ''
        },
        designPreferences: {
            natives: false
        },
        drawingsPath: 'drawings',
        pricingPath: 'pricing',
        photosPath: 'photos',
        dimensionsPath: 'dimensions'
    };
    return Object.assign(Object.assign({}, init), design);
}
